import {FC, useMemo, useState} from 'react'
import {Card, Spinner} from 'react-bootstrap'
import {SubClient} from '../../../../../services/cellcast.v2.types'
import WriteUser, {WriteUserMode} from '../Modal/WriteUser'
import UpdatePassword from '../Modal/UpdatePassword'

export type ProfileProps = {
  isFetching: boolean
  data: SubClient | undefined
  reload: () => void
}

const Profile: FC<ProfileProps> = (props) => {
  // extract props
  const {isFetching, data, reload} = props
  // const data
  const detailInformation = [
    {lable: 'Company', value: data?.companyName},
    {lable: 'Email', value: data?.email},
    {lable: 'Phone', value: data?.mobile},
    {lable: 'Industry', value: data?.industry},
    {lable: 'Website', value: data?.companyWebsite},
  ]
  // local state
  const [showEditModal, setShowEditModal] = useState(false)
  const [showEditPasswordModal, setShowEditPasswordModal] = useState(false)

  // handler
  const handleUpdate = () => setShowEditModal(true)
  const handleUpdatePassword = () => setShowEditPasswordModal(true)

  // memoise component
  const EditModal = useMemo(
    () => (
      <WriteUser
        handleClose={() => setShowEditModal(false)}
        callbackFn={() => {
          reload()
          setShowEditModal(false)
        }}
        mode={WriteUserMode.UPDATE}
        show={showEditModal}
        selectedData={data}
      />
    ),
    [data, reload, showEditModal]
  )

  const EditPasswordModal = useMemo(
    () => (
      <UpdatePassword
        handleClose={() => setShowEditPasswordModal(false)}
        callbackFn={() => setShowEditPasswordModal(false)}
        show={showEditPasswordModal}
        userId={data ? data._id : ''}
      />
    ),
    [data, showEditPasswordModal]
  )

  return (
    <>
      {data && EditModal}
      {data && EditPasswordModal}
      <Card className='mb-6'>
        {isFetching ? (
          <Card.Body className='pt-9 pb-0 h-500'>
            <div className='d-flex flex-wrap flex-sm-nowrap flex-column align-items-center  mb-10'>
              <Spinner className='mb-5' />
              <span>Fetching data ....</span>
            </div>
          </Card.Body>
        ) : (
          <Card.Body className='pt-9 pb-0'>
            <div className='d-flex flex-wrap flex-sm-nowrap flex-column align-items-center'>
              <div className='mb-4'>
                <div className='symbol symbol-100px symbol-fixed position-relative'>
                  {data?.avatar && data?.avatar !== 'undefined' ? (
                    <img className='rounded-circle' src={data?.avatar} alt='' />
                  ) : (
                    <span className='circle1'>{`${
                      data?.firstName !== undefined && data?.firstName !== ''
                        ? data?.firstName?.split('')[0]?.toUpperCase()
                        : ''
                    }${
                      data?.lastName !== undefined && data?.lastName !== ''
                        ? data?.lastName?.split('')[0]?.toUpperCase()
                        : ''
                    }`}</span>
                  )}
                  <div
                    className={`position-absolute translate-middle bottom-0 start-100 mb-6 rounded-circle border border-4 border-white h-20px w-20px ${
                      data?.status2 === 'active'
                        ? ' bg-success '
                        : data?.status2 === 'inactive'
                        ? 'bg-secondary'
                        : 'bg-danger'
                    }`}
                  ></div>
                </div>
              </div>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2 justify-content-center'>
                  <div className='d-flex flex-column align-items-center w-100'>
                    <div className='d-flex align-items-center mb-2'>
                      <span className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        {data?.name}
                      </span>
                    </div>
                    <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 justify-content-center '>
                      <span className='d-flex align-items-center mb-2 badge badge-light-info fs-6 py-2'>
                        {data?.role ? data.role : '-'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex mb-2'>
              <div className='accordion w-100' id='kt_accordion_1'>
                <div className='accordion-item border-0'>
                  <h2
                    className='accordion-header align-items-baseline gap-19 border-bottom pb-3 d-flex'
                    id='kt_accordion_1_header_1'
                  >
                    <button
                      className='accordion-button bg-transparent fs-4 fw-bolder collapsed py-3 px-4 mt-4'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#kt_accordion_1_body_1'
                      aria-expanded='false'
                      aria-controls='kt_accordion_1_body_1'
                    >
                      <span className='d-inline-flex me-4'>Account Details</span>
                    </button>
                    <button
                      onClick={() => handleUpdate()}
                      className='btn btn-light-primary btn-sm me-2'
                      id='kt_user_follow_button'
                    >
                      <span className='svg-icon svg-icon-3 d-none'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width={24}
                          height={24}
                          viewBox='0 0 24 24'
                          fill='none'
                        >
                          <path
                            opacity='0.3'
                            d='M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                            fill='currentColor'
                          />
                          <path
                            d='M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                      <span className='indicator-label'>Edit</span>
                    </button>
                  </h2>
                  <div
                    id='kt_accordion_1_body_1'
                    className='accordion-collapse collapse'
                    aria-labelledby='kt_accordion_1_header_1'
                    data-bs-parent='#kt_accordion_1'
                  >
                    <div className='accordion-body px-0'>
                      <div className='card-body p-0'>
                        {detailInformation.map((data: any, id: number) => (
                          <div key={id} className='row mb-7'>
                            <label className='col-lg-12 fw-bolder text-gray-800'>
                              {data?.lable}
                            </label>
                            <div className='col-lg-12'>
                              <span className='fw-semibold fs-6 text-muted'>{data && data?.value ? data.value: '-'}</span>
                            </div>
                          </div>
                        ))}

                        <div className='row mb-7'>
                          <label className='col-lg-12 fw-bolder text-gray-800'>Password</label>
                          <div className='col-lg-6 pt-1'>
                            <span className='fw-semibold fs-6 text-muted'>*************</span>
                          </div>
                          <div className='col-lg-6'>
                            <button
                              onClick={() => handleUpdatePassword()}
                              className='btn p-0 link-primary'
                            >
                              Change Password
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card.Body>
        )}
      </Card>
    </>
  )
}

export default Profile
